<template>
    <div class="announcements fts-table-wrapper">
        <div class="announcements-topbar">
            <div class="left-side">
                <h1>Announcements</h1>
                <p>Create and edit announcements which will be prompt for users upon login.</p>
            </div>
            <div class="right-side">
                <button @click="addAnnouncementShow()" class="btn btn-primary">
                    <i class="fa fa-plus"></i>
                    Add Announcement
                </button>
            </div>
        </div>
        <div class="filter-row">
            <div class="search-filter">
                <div class="search-box">
                    <input type="text" id="bulkSearch" class="form-control" v-model="filter" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search">
                </div>
                <div class="show-all-announcements">
                    <c-switch @change.native="getAnnouncements(true)" v-model="sortSettings.showExpired" cclass="mx-1" color="primary" variant="pill" label dataOn="✓" dataOff="✕"/>
                    <span class="show-expired-label">Show expired announcements</span>
                </div>
            </div>
            <div class="text-right">
                <label for="size-page">Display:</label>
                <select v-on:change="sizePage" v-model="sortSettings.size" id="size-page" class="form-control">
                    <option value="40">40</option>
                    <option value="60">60</option>
                    <option value="80">80</option>
                    <option value="100">100</option>
                </select>
            </div>
        </div>
        <div class="fts-table table-responsive-sm">
            <table  v-if='announcementsList' class="table b-table table-striped table-hover b-table-selectable b-table-select-multi table-managment">
                <thead role="rowgroup">
                <tr role="row">
                    <th v-on:click="changeSort(1)" :aria-sort="setAreaSort(1)">Created</th>
                    <th v-on:click="changeSort(2)" :aria-sort="setAreaSort(2)">Pushed Out</th>
                    <th v-on:click="changeSort(3)" :aria-sort="setAreaSort(3)">Template</th>
                    <th>Title</th>
                    <th>Expiration date</th>
                    <th></th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="(item, index) in announcementsList" v-bind:key="index">
                    <td>{{item.dateCreated}}</td>
                    <td>{{item.postOutDate}}</td>
                    <td>{{item.type.displayName}}</td>
                    <td>{{item.htmlElements.title}}</td>
                    <td>{{item.expirationDate}}</td>
                    <td>
                        <button :class="['btn', 'btn-primary', 'btn-announcement', item.expired ? 'announcement-expired' : '']" @click="announcementEdit(item)"><i class="fa fa-pencil"></i></button>
                        <button class="btn btn-primary btn-announcement" @click="announcementPreview(item)"><i class="fa fa-search"></i></button>
                        <button :class="['btn', 'btn-primary', 'btn-announcement', item.expired ? 'announcement-expired' : '']"  @click="announcementExpire(item.announcementId, item.expirationDate ? true : false)"><i class="fa fa-window-close-o"></i></button>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="no-announcements" v-if="noAnnouncements == true && loadingAnnouncements == false">
                <h2 class="text">You have no Announcements</h2>
            </div>
        </div>
        <div class="fts-bottom-table">
            <nav v-if="paginationCount" aria-label="Page navigation example">
                <paginate :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></paginate>
            </nav>
        </div>
        <div class="loader-announcements-list" v-if="loadingAnnouncements == true && noAnnouncements == false">
            <div class="sk-wave">
                <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
            </div>
        </div>
        <b-modal ref="addAnnouncement" id="addAnnouncement" size="lg" centered hide-header hide-footer>
            <i class="fa fa-close close-add-announcement" @click="closeNewAnnoucement()"></i>
            <img src="../../assets/img/announcement-icon.svg" alt="" class="announcement-icon">
            <h3>Add Announcement</h3>
            <div class="create-announcement">
                <div class="announcement-inputs">
                    <label for="selectTemplate">Select Template</label>
                    <select v-model="templateSelected" @change="changeTemplate()" name="select-template" id="selectTemplate" class="form-control custom-select announcement-select">
                        <option value="MAINTENANCE">Maintenance</option>
                        <option value="WORKING_ON_ISSUE">Working on Issue</option>
                        <option value="RELEASE_NOTES">Release Notes</option>
                        <option value="IMPORTANT_INFORMATION">Important Information</option>
                        <option value="COMPONENT_ISSUE">Compontent Issue</option>
                    </select>
                    <label for="announcementTitle">Title</label>
                    <input @keyup="generatePreview()" v-model="announcementElements.title" class="title-input" type="text" id="announcementTitle">
                    <div class="time-and-date-row">
                        <div class="column">
                            <div class="header-row">
                                <h5>Start Date</h5>
                                <h6>Optional</h6>
                            </div>
                            <date-picker v-model="startDate" class="datepicker" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                            <span v-if="errorMsgs.startDate" class="error-msg">{{errorMsgs.startDate}}</span>
                        </div>
                        <div class="column">
                            <div class="header-row">
                                <h5>Start Time</h5>
                                <h6>Optional</h6>
                            </div>
                            <b-form-timepicker v-model="startTime" :reset-button="true" :dropup="true" :hourCycle="'h11'" :locale="'en-US'"></b-form-timepicker>
                            <span v-if="errorMsgs.startTime" class="error-msg">{{errorMsgs.startTime}}</span>
                        </div>
                    </div>
                    <div class="time-and-date-row">
                        <div class="column">
                            <div class="header-row">
                                <h5>End Date</h5>
                                <h6>Optional</h6>
                            </div>
                            <date-picker v-model="endDate" class="datepicker" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                            <span v-if="errorMsgs.endDate" class="error-msg">{{errorMsgs.endDate}}</span>
                        </div>
                        <div class="column">
                            <div class="header-row">
                                <h5>End Time</h5>
                                <h6>Optional</h6>
                            </div>
                            <b-form-timepicker v-model="endTime" :reset-button="true" :dropup="true" :hourCycle="'h11'" :locale="'en-US'"></b-form-timepicker>
                            <span v-if="errorMsgs.endTime" class="error-msg">{{errorMsgs.endTime}}</span>
                        </div>
                    </div>
                    <label for="mainText">Main Text</label>
                    <textarea @keyup="generatePreview()" v-model="announcementElements.mainText" class="announcement-textarea" id="mainText" cols="20" rows="8"></textarea>
                    <div class="annoucements-expire-row">
                        <div class="column">
                            <div class="header-row">
                                <h5>Announcement Date</h5>
                                <i class="fa fa-info-circle">
                                    <span>If Announcement Date will not be selected it will be automatically set as now</span>
                                </i>
                            </div>
                            <date-picker v-model="pushedOutDate" class="datepicker" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                            <span v-if="errorMsgs.pushedOutDate" class="error-msg">{{errorMsgs.pushedOutDate}}</span>
                        </div>
                        <div class="column">
                            <div class="header-row">
                                <h5>Time</h5>
                            </div>
                            <b-form-timepicker v-model="pushedOutTime" :reset-button="true" :dropup="true" :hourCycle="'h11'" :locale="'en-US'"></b-form-timepicker>
                            <span v-if="errorMsgs.pushedOutTime" class="error-msg">{{errorMsgs.pushedOutTime}}</span>
                        </div>
                    </div>
                    <div class="annoucements-expire-row">
                        <div class="column">
                            <div class="header-row">
                                <h5>Expiration Date</h5>
                                <h6>optional</h6>
                                <i class="fa fa-info-circle">
                                    <span>If Expiration Date will not be selected it will be displayed for user until he will not acknowledge it.</span>
                                </i>
                            </div>
                            <date-picker v-model="expireDate" class="datepicker" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                            <span v-if="errorMsgs.expireDate" class="error-msg">{{errorMsgs.expireDate}}</span>
                        </div>
                        <div class="column">
                            <div class="header-row">
                                <h5>Time</h5>
                            </div>
                            <b-form-timepicker v-model="expireTime" :reset-button="true" :dropup="true" :hourCycle="'h11'" :locale="'en-US'"></b-form-timepicker>
                            <span v-if="errorMsgs.expireTime" class="error-msg">{{errorMsgs.expireTime}}</span>
                        </div>
                    </div>
                </div>
                <div class="announcement-content">
                    <div v-html="contentPreview" class="announcement-preview"></div>
                </div>
            </div>
            <div class="control-bar">
                <button class="btn btn-light" @click="closeNewAnnoucement()">Cancel</button>
                <button class="btn btn-primary" @click="saveNewAnnouncement()">Save</button>
            </div>
        </b-modal>

        <b-modal ref="editAnnouncement" id="editAnnouncement" size="lg" centered hide-header hide-footer>
            <i class="fa fa-close close-add-announcement" @click="closeEditAnnouncement()"></i>
            <img src="../../assets/img/announcement-icon.svg" alt="" class="announcement-icon">
            <h3>Edit Announcement</h3>
            <div class="create-announcement">
                <div class="announcement-inputs">
                    <label for="editSelectTemplate">Select Template</label>
                    <select v-model="editAnnouncementElements.templateSelected" @change="changeTemplate()" name="select-template" id="editSelectTemplate" class="form-control custom-select announcement-select">
                        <option value="MAINTENANCE">Maintenance</option>
                        <option value="WORKING_ON_ISSUE">Working on Issue</option>
                        <option value="RELEASE_NOTES">Release Notes</option>
                        <option value="IMPORTANT_INFORMATION">Important Information</option>
                        <option value="COMPONENT_ISSUE">Compontent Issue</option>
                    </select>
                    <label for="editAnnouncementTitle">Title</label>
                    <input @keyup="generateEditPreview()" v-model="editAnnouncementElements.title" class="title-input" type="text" id="editAnnouncementTitle">
                    <div class="time-and-date-row">
                        <div class="column">
                            <div class="header-row">
                                <h5>Start Date</h5>
                                <h6>Optional</h6>
                            </div>
                            <date-picker v-model="editAnnouncementElements.startDate" class="datepicker" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                            <span v-if="errorMsgs.startDate" class="error-msg">{{errorMsgs.startDate}}</span>
                        </div>
                        <div class="column">
                            <div class="header-row">
                                <h5>Start Time</h5>
                                <h6>Optional</h6>
                            </div>
                            <b-form-timepicker v-model="editAnnouncementElements.startTime" :reset-button="true" :dropup="true" :hourCycle="'h11'" :locale="'en-US'"></b-form-timepicker>
                            <span v-if="errorMsgs.startTime" class="error-msg">{{errorMsgs.startTime}}</span>
                        </div>
                    </div>
                    <div class="time-and-date-row">
                        <div class="column">
                            <div class="header-row">
                                <h5>End Date</h5>
                                <h6>Optional</h6>
                            </div>
                            <date-picker v-model="editAnnouncementElements.endDate" class="datepicker" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                            <span v-if="errorMsgs.endDate" class="error-msg">{{errorMsgs.endDate}}</span>
                        </div>
                        <div class="column">
                            <div class="header-row">
                                <h5>End Time</h5>
                                <h6>Optional</h6>
                            </div>
                            <b-form-timepicker v-model="editAnnouncementElements.endTime" :reset-button="true" :dropup="true" :hourCycle="'h11'" :locale="'en-US'"></b-form-timepicker>
                            <span v-if="errorMsgs.endTime" class="error-msg">{{errorMsgs.endTime}}</span>
                        </div>
                    </div>
                    <label for="editMainText">Main Text</label>
                    <textarea @keyup="generatePreview()" v-model="editAnnouncementElements.text" class="announcement-textarea" id="editMainText" cols="20" rows="8"></textarea>
                    <div class="annoucements-expire-row">
                        <div class="column">
                            <div class="header-row">
                                <h5>Announcement Date</h5>
                                <i class="fa fa-info-circle">
                                    <span>If Announcement Date will not be selected it will be automatically set as now</span>
                                </i>
                            </div>
                            <date-picker v-model="editAnnouncementElements.pushedOutDate" class="datepicker" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                            <span v-if="errorMsgs.pushedOutDate" class="error-msg">{{errorMsgs.pushedOutDate}}</span>
                        </div>
                        <div class="column">
                            <div class="header-row">
                                <h5>Time</h5>
                            </div>
                            <b-form-timepicker v-model="editAnnouncementElements.pushedOutTime" :reset-button="true" :dropup="true" :hourCycle="'h11'" :locale="'en-US'"></b-form-timepicker>
                            <span v-if="errorMsgs.pushedOutTime" class="error-msg">{{errorMsgs.pushedOutTime}}</span>
                        </div>
                    </div>
                    <div class="annoucements-expire-row">
                        <div class="column">
                            <div class="header-row">
                                <h5>Expiration Date</h5>
                                <h6>optional</h6>
                                <i class="fa fa-info-circle">
                                    <span>If Expiration Date will not be selected it will be displayed for user until he will not acknowledge it.</span>
                                </i>
                            </div>
                            <date-picker v-model="editAnnouncementElements.expireDate" class="datepicker" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                            <span v-if="errorMsgs.expireDate" class="error-msg">{{errorMsgs.expireDate}}</span>
                        </div>
                        <div class="column">
                            <div class="header-row">
                                <h5>Time</h5>
                            </div>
                            <b-form-timepicker v-model="editAnnouncementElements.expireTime" :reset-button="true" :dropup="true" :hourCycle="'h11'" :locale="'en-US'"></b-form-timepicker>
                            <span v-if="errorMsgs.expireTime" class="error-msg">{{errorMsgs.expireTime}}</span>
                        </div>
                    </div>
                </div>
                <div class="announcement-content">
                    <div v-html="contentEditPreview" class="announcement-preview"></div>
                </div>
            </div>
            <div class="control-bar">
                <button class="btn btn-light" @click="closeEditAnnouncement()">Cancel</button>
                <button class="btn btn-primary" @click="saveEditAnnouncement()">Save</button>
            </div>
        </b-modal>
        <b-modal id="previewModal" ref="previewModal" centered hide-footer hide-header size="md">
            <div v-html="previewModalContent" class="content"></div>
        </b-modal>
        <b-modal id="expireModal" ref="expireModal" centered hide-footer hide-header size="md">
            <i @click="closeExpire()" class="fa fa-close"></i>
            <i class="fa fa-window-close-o"></i>
            <h3>Expire Announcement</h3>
            <p v-if="hasExpire">The selected Announcement has an expiration date.<br/>Do You still want it to be set as expired?</p>
            <p v-else>The selected Announcement will be set to Expired.</p>
            <div class="expire-btns">
                <button @click="closeExpire()" class="btn btn-light">Cancel</button>
                <button @click="confirmExpire()" class="btn btn-primary">Expire</button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Axios from 'axios'
    import globalStore from '../../variables'
    import Paginate from 'vuejs-paginate'
    import DatePicker from 'vue2-datepicker'
    import { Switch as cSwitch } from '@coreui/vue'

    export default {
        name: "Announcements",
        components: {
            Paginate,
            DatePicker,
            cSwitch
        },
        data() {
            return {
                announcementsList: [],
                paginationCount: 0,
                sortSettings: {
                    page: 1,
                    size: 40,
                    desc: true,
                    sort: 1,
                    showExpired: false
                },
                noAnnouncements: false,
                showExpired: false,
                loadingAnnouncements: false,
                filter: '',
                search: '',
                langDataPicker: {
                    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
                    placeholder: {
                        date: 'Select Date',
                        dateRange: 'Select Date Range'
                    }
                },
                startDate: null,
                endDate: null,
                startTime: null,
                endTime: null,
                pushedOutDate: null,
                pushedOutTime: null,
                expireDate: null,
                expireTime: null,
                defaultContent: {
                    maintenance: {
                        title: 'Planned Maintenance',
                        img: 'maintenance-img.svg',
                        mainText: 'We will be undergoing a scheduled maintenance. During this time access to the portal may be unavailable.'
                    },
                    workingOnIssue: {
                        title: 'Working On Found Issue',
                        img: 'working-on-issue-img.svg',
                        mainText: 'Working on issue test paragraph template'
                    },
                    releaseNotes: {
                        title: 'New Features',
                        img: 'new-features-img.svg',
                        mainText: 'Release notes test paragraph template.'
                    },
                    importantInformation: {
                        title: 'Important Information',
                        img: 'important-information-img.svg',
                        mainText: 'Imporant Information test paragraph template.'
                    },
                    componentIssue: {
                        title: 'Component offline',
                        img: 'component-offline-img.svg',
                        mainText: 'Component offline test paragraph template.'
                    }
                },
                announcementElements: {
                    title: 'Planned Maintenance',
                    mainText: 'We will be undergoing a scheduled maintenance on Sunday, 10.10.2021 between 7:00 AM - 11:00 AM EST. During this time access to the portal may be unavailable.'
                },
                errorMsgs: {},
                contentPreview: '',
                contentEditPreview: '',
                previewModalContent: '',
                expireId: null,
                hasExpire: false,
                templateSelected: 'MAINTENANCE',
                editAnnouncementElements: {}
            }
        },
        methods: {
            getAnnouncements(resetPage) {
                this.loadingAnnouncements = true
                this.noAnnouncements = false
                if(resetPage) {
                    this.sortSettings.page = 1
                    this.getPagination()
                }
                Axios.get(globalStore.data.restApiUrl + '/announcement/all?page=' + this.sortSettings.page + '&sort=' + this.sortSettings.sort + '&desc=' + this.sortSettings.desc + '&size=' + this.sortSettings.size + '&showExpired=' + this.sortSettings.showExpired + this.search)
                    .then(response => {
                        this.announcementsList = []
                        for (let item of response.data) {
                            let template = item
                            template.htmlElements = {
                                title: item.title,
                                text: item.htmlContent
                            }

                            if (template.startDateInfo != null) {
                                template.startDate = this.fixDateFormat(template.startDateInfo.substr(0, 10))
                                template.startTime = template.startDateInfo.substr(11, 15)
                                if (template.startTime.substr(0, 11) == '12:00:00 PM') {
                                    template.startTime = '12:00:00'
                                } else if (template.startTime.substr(0, 11) == '12:00:00 AM') {
                                    template.startTime = '00:00:00'
                                } else if (template.startTime.indexOf('PM') > -1) {
                                    template.startTime = String(Number(template.startTime.substr(0, 2)) + 12) + template.startTime.substr(2, 6)
                                } else {
                                    template.startTime = template.startTime.substr(0,8)
                                }
                            } else {
                                template.startDate = null
                                template.startTime = null
                            }

                            if (template.endDateInfo != null) {
                                template.endTime = template.endDateInfo.substr(11, 15)
                                template.endDate = this.fixDateFormat(template.endDateInfo.substr(0, 10))
                                if (template.endTime.substr(0, 11) == '12:00:00 PM') {
                                    template.endTime = '12:00:00'
                                } else if (template.endTime.substr(0, 11) == '12:00:00 AM') {
                                    template.endTime = '00:00:00'
                                } else if (template.endTime.indexOf('PM') > -1) {
                                    template.endTime = String(Number(template.endTime.substr(0, 2)) + 12) + template.endTime.substr(2, 6)
                                } else {
                                    template.endTime = template.endTime.substr(0,8)
                                }
                            } else {
                                template.endTime = null
                                template.endDate = null
                            }

                            if (template.expirationDate != null) {
                                if (new Date(template.expirationDate) < new Date()) {
                                    template.expired = true
                                } else {
                                    template.expired = false
                                }
                                template.expireDate = this.fixDateFormat(template.expirationDate.substr(0, 10))
                                template.expireTime = template.expirationDate.substr(11, 15)
                                if (template.expireTime.substr(0, 11) == '12:00:00 PM') {
                                    template.expireTime = '12:00:00'
                                } else if (template.expireTime.substr(0, 11) == '12:00:00 AM') {
                                    template.expireTime = '00:00:00'
                                } else if (template.expireTime.indexOf('PM') > -1) {
                                    template.expireTime = String(Number(template.expireTime.substr(0, 2)) + 12) + template.expireTime.substr(2, 6)
                                } else {
                                    template.expireTime = template.expireTime.substr(0,8)
                                }
                            } else {
                                template.expireDate = null
                                template.expireTime = null
                            }

                            if (template.postOutDate != null) {
                                template.pushedOutTime = template.postOutDate.substr(11, 11)
                                template.pushedOutDate = this.fixDateFormat(item.postOutDate.substr(0, 10))
                                if (template.pushedOutTime.substr(0, 11) == '12:00:00 PM') {
                                    template.pushedOutTime = '12:00:00'
                                } else if (template.pushedOutTime.substr(0, 11) == '12:00:00 AM') {
                                    template.pushedOutTime = '00:00:00'
                                } else if (template.pushedOutTime.indexOf('PM') > -1) {
                                    template.pushedOutTime = String(Number(template.pushedOutTime.substr(0, 2)) + 12) + template.pushedOutTime.substr(2, 6)
                                } else {
                                    template.pushedOutTime = template.pushedOutTime.substr(0,8)
                                }
                            } else {
                                template.pushedOutTime = null
                                template.pushedOutDate = null
                            }



                            delete template.htmlContent
                            delete template.title
                            this.announcementsList.push(template)
                        }

                        this.loadingAnnouncements = false
                        if (this.announcementsList.length == 0) {
                            this.noAnnouncements = true
                        }
                    })
                    .catch(error => {
                        this.loadingAnnouncements = false
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting announcements error.',
                            text: 'Something went wrong during getting announcements data. Please contact support.',
                            duration: 3000,
                        });
                        console.log(error)
                    })

            },
            getPagination() {
                Axios.get(globalStore.data.restApiUrl + '/announcement/all/page-count?size=' + this.sortSettings.size + '&showExpired=' + this.sortSettings.showExpired + this.search)
                    .then(response => {
                        this.paginationCount = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            announcementPreview(html) {//here
                this.generatePreviewModal(html)
                this.$refs['previewModal'].show()
            },
            generatePreviewModal(item) {
                let parsedData = {
                    title: item.htmlElements.title,
                    text: item.htmlElements.text,
                    startDate: item.startDate,
                    startTime: item.startTime,
                    endTime: item.endTime,
                    endDate: item.endDate,
                    expireDate: item.expireDate,
                    expireTime: item.expireTime,
                    pushedOutTime: item.pushedOutTime,
                    pushedOutDate: item.pushedOutDate,
                    templateSelected: item.type.serverName,
                    announcementId: item.announcementId
                }

                if (parsedData.templateSelected == 'MAINTENANCE') {
                    parsedData.img = 'maintenance-img.svg'
                } else if (parsedData.templateSelected == 'WORKING_ON_ISSUE') {
                    parsedData.img = 'working-on-issue-img.svg'
                } else if (parsedData.templateSelected == 'RELEASE_NOTES') {
                    parsedData.img = 'new-features-img.svg'
                } else if (parsedData.templateSelected == 'IMPORTANT_INFORMATION') {
                    parsedData.img = 'important-information-img.svg'
                } else if (parsedData.templateSelected == 'COMPONENT_ISSUE') {
                    parsedData.img = 'component-offline-img.svg'
                }

                this.previewModalContent = ''
                this.previewModalContent = this.previewModalContent + '<img src="img/announcement-icon.svg" alt="" class="announcement-icon">'
                this.previewModalContent = this.previewModalContent + '<h3>' + parsedData.title + '</h3>'
                this.previewModalContent = this.previewModalContent + '<img class="announcement-image" src="' + 'img/' + parsedData.img + '"/>'
                this.previewModalContent = this.previewModalContent + '<p>' + parsedData.text + '</p>'

            },
            announcementExpire(announcementId, hasExpire) {
                this.expireId = announcementId
                this.hasExpire = hasExpire
                this.$refs['expireModal'].show()
            },
            confirmExpire() {
                Axios.patch(globalStore.data.restApiUrl + '/announcement/expire?announcementId=' + this.expireId)
                    .then(response => {
                        this.closeExpire()
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Announcement expired.',
                            text: 'Announcement has been expired successful.',
                            duration: 3000,
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Announcement not expired.',
                            text: 'Announcement has not been expired. Please, contact support.',
                            duration: 3000,
                        });
                        console.log(error)
                    })
            },
            closeExpire() {
                this.$refs['expireModal'].hide()
                this.expireId = null
                this.hasExpire = false
            },
            fixDateFormat(date) {
                return (date.substr(6,4) + '-' + date.substr(0,2) + '-' + date.substr(3,2))

            },
            announcementEdit(item) {
                this.errorMsgs = {
                    count: 0
                }
                this.editAnnouncementElements = {
                    title: item.htmlElements.title,
                    text: item.htmlElements.text,
                    startDate: item.startDate,
                    startTime: item.startTime,
                    endTime: item.endTime,
                    endDate: item.endDate,
                    expireDate: item.expireDate,
                    expireTime: item.expireTime,
                    pushedOutTime: item.pushedOutTime,
                    pushedOutDate: item.pushedOutDate,
                    templateSelected: item.type.serverName,
                    announcementId: item.announcementId
                }

                if (this.editAnnouncementElements.templateSelected == 'MAINTENANCE') {
                    this.editAnnouncementElements.img = 'maintenance-img.svg'
                } else if (this.editAnnouncementElements.templateSelected == 'WORKING_ON_ISSUE') {
                    this.editAnnouncementElements.img = 'working-on-issue-img.svg'
                } else if (this.editAnnouncementElements.templateSelected == 'RELEASE_NOTES') {
                    this.editAnnouncementElements.img = 'new-features-img.svg'
                } else if (this.editAnnouncementElements.templateSelected == 'IMPORTANT_INFORMATION') {
                    this.editAnnouncementElements.img = 'important-information-img.svg'
                } else if (this.editAnnouncementElements.templateSelected == 'COMPONENT_ISSUE') {
                    this.editAnnouncementElements.img = 'component-offline-img.svg'
                }
                this.$refs['editAnnouncement'].show()
                this.generateEditPreview()
            },
            addAnnouncementShow() {
                this.$refs['addAnnouncement'].show()
                this.changeTemplate();
            },
            closeNewAnnoucement() {
                this.$refs['addAnnouncement'].hide()
            },
            changeTemplate() {
                if (this.templateSelected == "MAINTENANCE") {
                    this.announcementElements.title = this.defaultContent.maintenance.title
                    this.announcementElements.mainText = this.defaultContent.maintenance.mainText
                    this.announcementElements.img = 'maintenance-img.svg'
                } else if (this.templateSelected == "WORKING_ON_ISSUE") {
                    this.announcementElements.title = this.defaultContent.workingOnIssue.title
                    this.announcementElements.mainText = this.defaultContent.workingOnIssue.mainText
                    this.announcementElements.img = 'working-on-issue-img.svg'
                } else if (this.templateSelected == "RELEASE_NOTES") {
                    this.announcementElements.title = this.defaultContent.releaseNotes.title
                    this.announcementElements.mainText = this.defaultContent.releaseNotes.mainText
                    this.announcementElements.img = 'new-features-img.svg'
                } else if (this.templateSelected == "IMPORTANT_INFORMATION") {
                    this.announcementElements.title = this.defaultContent.importantInformation.title
                    this.announcementElements.mainText = this.defaultContent.importantInformation.mainText
                    this.announcementElements.img = 'important-information-img.svg'
                } else if (this.templateSelected == "COMPONENT_ISSUE") {
                    this.announcementElements.title = this.defaultContent.componentIssue.title
                    this.announcementElements.mainText = this.defaultContent.componentIssue.mainText
                    this.announcementElements.img = 'component-offline-img.svg'
                }
                this.parseIntoHTML()
            },
            saveNewAnnouncement() {
                let parsedData = {
                    title: this.announcementElements.title,
                    content: this.announcementElements.mainText,
                    announcementType: this.templateSelected
                }
                this.errorMsgs = {
                    count: 0
                }

                if ((this.pushedOutDate != null && this.pushedOutDate != '') || (this.pushedOutTime != null && this.pushedOutTime != '')) {
                    let correctDate = true
                    if (this.pushedOutTime == null || this.pushedOutTime == '') {
                        this.errorMsgs.count++
                        this.errorMsgs.pushedOutTime = 'Time must be also set.'
                        correctDate = false
                    }

                    if (this.pushedOutDate == null || this.pushedOutDate == '') {
                        this.errorMsgs.count++
                        this.errorMsgs.pushedOutDate = 'Date must be also set.'
                        correctDate = false
                    }
                    if (correctDate) {
                        parsedData.postOutDate = this.pushedOutDate + ' ' + this.pushedOutTime
                    }
                }

                if ((this.expireDate != null && this.expireDate != '') || (this.expireTime != null && this.expireTime != '')) {
                    let correctDate = true
                    if (this.expireTime == null || this.expireTime == '') {
                        this.errorMsgs.count++
                        this.errorMsgs.expireTime = 'Time must be also set.'
                        correctDate = false
                    }
                    if (this.expireDate == null || this.expireDate == '') {
                        this.errorMsgs.count++
                        this.errorMsgs.expireDate = 'Date must be also set.'
                        correctDate = false
                    }
                    if (correctDate) {
                        parsedData.expirationDate = this.expireDate + ' ' + this.expireTime
                    }
                }

                if (parsedData.postOutDate && parsedData.expirationDate) {
                    if (new Date(parsedData.postOutDate) > new Date(parsedData.expirationDate)) {
                        this.errorMsgs.count++
                        this.errorMsgs.expireDate = 'Announcement date is later then end.'
                    }
                }

                if ((this.startDate != null && this.startDate != '') || (this.startTime != null && this.startTime != '')) {
                    let correctDate = true
                    if (this.startTime == null || this.startTime == '') {
                        this.errorMsgs.count++
                        this.errorMsgs.startTime = 'Time must be also set.'
                        correctDate = false
                    }

                    if (this.startDate == null || this.startDate == '') {
                        this.errorMsgs.count++
                        this.errorMsgs.startDate = 'Date must be also set.'
                        correctDate = false
                    }
                    if (correctDate) {
                        parsedData.startDateInfo = this.startDate + ' ' + this.startTime
                    }
                }
                if ((this.endDate != null && this.endDate != '') || (this.endTime != null && this.endTime != '')) {
                    let correctDate = true
                    if (this.endTime == null || this.endTime == '') {
                        this.errorMsgs.count++
                        this.errorMsgs.endTime = 'Time must be also set.'
                        correctDate = false
                    }
                    if (this.endDate == null || this.endDate == '') {
                        this.errorMsgs.count++
                        this.errorMsgs.endDate = 'Date must be also set.'
                        correctDate = false
                    }
                    if (correctDate) {
                        parsedData.endDateInfo = this.endDate + ' ' + this.endTime
                    }
                }

                if (parsedData.startDateInfo && parsedData.endDateInfo) {
                    if (new Date(parsedData.startDateInfo) > new Date(parsedData.endDateInfo)) {
                        this.errorMsgs.count++
                        this.errorMsgs.endDate = 'Start date is later then end.'
                    }
                }

                if(this.errorMsgs.count) {
                    return false
                }

                Axios.post(globalStore.data.restApiUrl + '/announcement/new', parsedData)
                    .then(response => {
                        this.getAnnouncements(true)
                        this.$refs['addAnnouncement'].hide();
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'New announcement created.',
                            text: 'You successfully made new announcement.',
                            duration: 3000,
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Creating announcements error.',
                            text: 'Something went wrong during creating new announcement. Please contact support.',
                            duration: 3000,
                        });
                        console.log(error)
                    })
            },
            saveEditAnnouncement() {
                this.errorMsgs = {
                    count: 0
                }

                let parsedData = {
                    title: this.editAnnouncementElements.title,
                    content: this.editAnnouncementElements.text,
                    announcementType: this.editAnnouncementElements.templateSelected
                }

                if ((this.editAnnouncementElements.pushedOutDate != null && this.editAnnouncementElements.pushedOutDate != '') || (this.editAnnouncementElements.pushedOutTime != null && this.editAnnouncementElements.pushedOutTime != '')) {
                    let correctDate = true
                    if (this.editAnnouncementElements.pushedOutTime == null || this.editAnnouncementElements.pushedOutTime == '') {
                        this.errorMsgs.count++
                        this.errorMsgs.pushedOutTime = 'Time must be also set.'
                        correctDate = false
                    }

                    if (this.editAnnouncementElements.pushedOutDate == null || this.editAnnouncementElements.pushedOutDate == '') {
                        this.errorMsgs.count++
                        this.errorMsgs.pushedOutDate = 'Date must be also set.'
                        correctDate = false
                    }
                    if (correctDate) {
                        parsedData.postOutDate = this.editAnnouncementElements.pushedOutDate + ' ' + this.editAnnouncementElements.pushedOutTime
                    }
                }

                if ((this.editAnnouncementElements.expireDate != null && this.editAnnouncementElements.expireDate != '') || (this.editAnnouncementElements.expireTime != null && this.editAnnouncementElements.expireTime != '')) {
                    let correctDate = true
                    if (this.editAnnouncementElements.expireTime == null || this.editAnnouncementElements.expireTime == '') {
                        this.errorMsgs.count++
                        this.errorMsgs.expireTime = 'Time must be also set.'
                        correctDate = false
                    }
                    if (this.editAnnouncementElements.expireDate == null || this.editAnnouncementElements.expireDate == '') {
                        this.errorMsgs.count++
                        this.errorMsgs.expireDate = 'Date must be also set.'
                        correctDate = false
                    }
                    if (correctDate) {
                        parsedData.expirationDate = this.editAnnouncementElements.expireDate + ' ' + this.editAnnouncementElements.expireTime
                    }
                }

                if (parsedData.postOutDate && parsedData.expirationDate) {
                    if (new Date(parsedData.postOutDate) > new Date(parsedData.expirationDate)) {
                        this.errorMsgs.count++
                        this.errorMsgs.pushedOutDate = 'Annoucement date is later then end.'
                    }
                }

                if ((this.editAnnouncementElements.startDate != null && this.editAnnouncementElements.startDate != '') || (this.editAnnouncementElements.startTime != null && this.editAnnouncementElements.startTime != '')) {
                    let correctDate = true
                    if (this.editAnnouncementElements.startTime == null || this.editAnnouncementElements.startTime == '') {
                        this.errorMsgs.count++
                        this.errorMsgs.startTime = 'Time must be also set.'
                        correctDate = false
                    }

                    if (this.editAnnouncementElements.startDate == null || this.editAnnouncementElements.startDate == '') {
                        this.errorMsgs.count++
                        this.errorMsgs.startDate = 'Date must be also set.'
                        correctDate = false
                    }
                    if (correctDate) {
                        parsedData.startDateInfo = this.editAnnouncementElements.startDate + ' ' + this.editAnnouncementElements.startTime
                    }
                }
                if ((this.editAnnouncementElements.endDate != null && this.editAnnouncementElements.endDate != '') || (this.editAnnouncementElements.endTime != null && this.editAnnouncementElements.endTime != '')) {
                    let correctDate = true
                    if (this.editAnnouncementElements.endTime == null || this.editAnnouncementElements.endTime == '') {
                        this.errorMsgs.count++
                        this.errorMsgs.endTime = 'Time must be also set.'
                        correctDate = false
                    }
                    if (this.editAnnouncementElements.endDate == null || this.editAnnouncementElements.endDate == '') {
                        this.errorMsgs.count++
                        this.errorMsgs.endDate = 'Date must be also set.'
                        correctDate = false
                    }
                    if (correctDate) {
                        parsedData.endDateInfo = this.editAnnouncementElements.endDate + ' ' + this.editAnnouncementElements.endTime
                    }
                }

                if (parsedData.startDateInfo && parsedData.endDateInfo) {
                    if (new Date(parsedData.startDateInfo) > new Date(parsedData.endDateInfo)) {
                        this.errorMsgs.count++
                        this.errorMsgs.endDate = 'Start date is later then end.'
                    }
                }

                if (this.errorMsgs.count) {
                    return false
                }

                Axios.put(globalStore.data.restApiUrl + '/announcement/' + this.editAnnouncementElements.announcementId, parsedData)
                    .then(response => {
                        this.getAnnouncements(true)
                        this.$refs['editAnnouncement'].hide();
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Announcement edition saved.',
                            text: 'You successfully edited announcement.',
                            duration: 3000,
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Editing announcements error.',
                            text: 'Something went wrong during edition of announcement. Please contact support.',
                            duration: 3000,
                        });
                        console.log(error)
                    })
            },
            closeEditAnnouncement() {
                this.editAnnouncementElements = {}
                this.$refs['editAnnouncement'].hide();
            },
            changeSort(sortId) {
                if (sortId == this.sortSettings.sort) {
                    this.sortSettings.desc = !this.sortSettings.desc
                }
                this.sortSettings.sort = sortId
                this.getAnnouncements(false)
            },
            setAreaSort(sortId) {
                if (sortId != this.sortSettings.sort) {
                    return 'none'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc) {
                    return 'descending'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc == false) {
                    return 'ascending'
                }
            },
            searchKeyUp() {
                clearTimeout(this.typingTimer)
                this.typingTimer = setTimeout(() => {
                    this.searchRow()
                }, 500)
            },
            searchKeyDown() {
                clearTimeout(this.typingTimer)
            },
            searchRow: function () {
                if (this.filter.length > 0) {
                    this.search = '&search=' + escape(this.filter);
                } else {
                    this.search = '';
                }
                this.getAnnouncements(true);
            },
            sizePage() {
                this.getAnnouncements(true);
            },
            paginationControll(ev) {
                this.loading = true;
                this.sortSettings.page = ev;
                this.getAnnouncements(false);
            },
            parseDate (data) {
                let parsedData = data.replace(/ /g,"T") + 'Z';
                parsedData = new Date(parsedData);
                let finalDate = ("0" + (parsedData.getMonth() + 1)).slice(-2) + '-' + ("0" + parsedData.getDate()).slice(-2) + '-' + parsedData.getFullYear();
                return finalDate;
            },
            setTimeToLocal (data) {
                let dateHistoryTime = new Date(data.getTime());

                if (dateHistoryTime.getHours() > 12) {
                    let tempHour = (dateHistoryTime.getHours() + 24) % 12 || 12;
                    if (dateHistoryTime.getMinutes() == 59) {
                        var hoursHistory = tempHour + ':' + ("0" + dateHistoryTime.getMinutes()).slice(-2) + ' PM'
                    } else {
                        var hoursHistory = tempHour + ':' + ("0" + dateHistoryTime.getMinutes()).slice(-2) + ' PM'
                    }
                } else {
                    if (dateHistoryTime.getHours() == 0) {
                        var hoursHistory = '12' + ':' + ("0" + dateHistoryTime.getMinutes()).slice(-2) + ' AM'
                    } else {
                        var hoursHistory = dateHistoryTime.getHours() + ':' + ("0" + dateHistoryTime.getMinutes()).slice(-2) + ' AM'
                    }
                }

                let finalDate = data.getMonth() + 1 + '/' + data.getDate() + '/' + data.getFullYear() + ' ' + hoursHistory;
                return finalDate;
            },
            parseIntoHTML() {
                this.contentPreview = ''
                this.contentPreview = this.contentPreview + '<img src="img/announcement-icon.svg" alt="" class="announcement-icon">'
                this.contentPreview = this.contentPreview + '<h3>' + this.announcementElements.title + '</h3>'
                if (this.startDate && this.endDate && this.startTime && this.endTime) {
                    this.contentPreview = this.contentPreview + '<h4>' + this.parseDate(this.startDate) + ' ' + this.startTime + ' - ' + this.parseDate(this.endDate) + ' ' + this.endTime + '</h4>'
                }
                this.contentPreview = this.contentPreview + '<img class="announcement-image" src="' + 'img/' + this.announcementElements.img + '"/>'
                this.contentPreview = this.contentPreview + '<p>' + this.announcementElements.mainText + '</p>'
            },
            parseEditIntoHTML() {
                this.contentEditPreview = ''
                this.contentEditPreview = this.contentEditPreview + '<img src="img/announcement-icon.svg" alt="" class="announcement-icon">'
                this.contentEditPreview = this.contentEditPreview + '<h3>' + this.editAnnouncementElements.title + '</h3>'
                this.contentEditPreview = this.contentEditPreview + '<img class="announcement-image" src="' + 'img/' + this.editAnnouncementElements.img + '"/>'
                this.contentEditPreview = this.contentEditPreview + '<p>' + this.editAnnouncementElements.text + '</p>'

            },
            generatePreview() {
                clearTimeout(this.typingTimer)
                this.typingTimer = setTimeout(() => {
                    this.parseIntoHTML()
                }, 500)
            },
            generateEditPreview() {
                clearTimeout(this.typingTimer)
                this.typingTimer = setTimeout(() => {
                    this.parseEditIntoHTML()
                }, 500)
            }
        },
        mounted() {
            this.getAnnouncements(true)
        }
    }
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />
<style lang="scss">
    .announcements {
        padding: 20px 0;
        background-color: #fff;
        .announcements-topbar {
            display: flex;
            justify-content: space-between;
            padding: 0 20px;
            .left-side {
                h1 {
                    font-size: 15px;
                    font-weight: 700;
                }
                p {
                    margin: 1rem;
                }
            }
            .right-side {
                .btn-primary {
                    display: flex;
                    align-items: center;
                    .fa-plus {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 18px;
                        height: 18px;
                        border: 2px solid #fff;
                        border-radius: 100%;
                        &::before {
                            font-size: 10px;
                        }
                    }
                }
            }
        }
        .filter-row {
            display: flex;
            justify-content: space-between;
            padding: 20px;
            border-top: 1px solid #c9cfd4;
            border-bottom: 1px solid #c9cfd4;
            .search-box {
                display: flex;
                align-items: center;
                border: 1px solid #c9cfd4;
                background-color: #f0f3f5;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                &:before {
                    content: '\f002';
                    font-family: "FontAwesome";
                    margin: 0 0 0 10px;
                    color: #727A82;
                }
                input {
                    background-color: #f0f3f5;
                    border: 0;
                    outline: none;
                    &:focus {
                        outline: none;
                    }
                }
            }
            .text-right {
                display: flex;
                align-items: center;
                label {
                    margin: 0 10px 0 0;
                }
                .form-control {
                    width: 60px;
                    background: url('data:image/svg+xml,%3Csvg version=\'1.1\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' x=\'0px\' y=\'0px\' viewBox=\'0 0 8 4.2\' style=\'enable-background:new 0 0 8 4.2;\' xml:space=\'preserve\'%3E%3Cstyle type=\'text/css\'%3E .st0%7Bfill:%230088FF;%7D%0A%3C/style%3E%3Cpolygon class=\'st0\' points=\'4,4.2 0,0 8,0 \'/%3E%3C/svg%3E%0A') no-repeat right 0.75rem center/8px 10px #ffffff;
                }
            }
            .search-filter {
                display: flex;
                align-items: center;
                .show-all-announcements {
                    display: flex;
                    align-items: center;
                    .switch {
                        margin-left: 20px;
                    }
                    .show-expired-label {
                        margin-left: 12px;
                    }
                }
            }
        }
        .fts-table {
            position: relative;
            .btn-announcement {
                margin: 0 12px 0 0;
                background-color: #00b1ff;
                &.announcement-expired {
                    opacity: 0.5;
                    pointer-events: none;
                }
                &:last-child {
                    margin: 0;
                }
                i {
                    margin: 0;
                }
            }
        }
        .fts-bottom-table {
            position: relative;
            justify-content: center;
        }

        .loader-announcements-list,
        .no-announcements {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;

            background-color: rgba(255, 255, 255, 0.7);

            display: flex;
            justify-content: center;
            align-items: center;
            align-content: center;

            .sk-wave {
                height: 60px;
                .sk-rect {
                    width: 3px;
                    background-color: #39c354;
                    border-radius: 4px;
                }
            }

            .text {
                margin-top: 20px;
                text-align: center;
                font-size: 15px;
                font-weight: 700;
            }

            h2.text {
                margin-top: 180px;
            }
        }
    }

    #addAnnouncement,
    #editAnnouncement {
        .modal-lg {
            max-width: 920px;
        }
    }

    #editAnnouncement___BV_modal_body_,
    #addAnnouncement___BV_modal_body_ {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0;
        .close-add-announcement {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
        }

        .announcement-icon {
            margin: 20px 0 8px;
        }

        h3 {
            font-size: 15px;
        }

        .create-announcement {
            width: 100%;
            display: flex;
            padding: 0 20px;
            .announcement-inputs {
                flex-grow: 1;
            }
            .announcement-content {
                width: 540px;
            }
            .announcement-inputs {
                display: flex;
                flex-direction: column;
                .fa-info-circle {
                    position: relative;
                    &:before {
                        color: #c9cfd4;
                    }
                    span {
                        position: absolute;
                        bottom: calc(100% + 10px);
                        display: none;
                        min-width: 250px;
                        padding: 12px;
                        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
                        background-color: #f0f3f5;
                        border: 1px solid #c9cfd4;
                        -webkit-border-radius: 5px;
                        -moz-border-radius: 5px;
                        border-radius: 5px;
                    }
                    &:hover {
                        span {
                            display: initial;
                        }
                    }
                }
                .announcement-select {
                    margin-bottom: 20px;
                }
                .title-input {
                    margin: 0 0 20px;
                    padding: 6px 12px;
                    background-color: #f0f3f5;
                    border: 1px solid #C9CFD4;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    &:focus {
                        outline: none;
                    }
                }
                .time-and-date-row {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    .column {
                        position: relative;
                        display: flex;
                        flex-direction: column;
                        width: calc(50% - 10px);
                        .form-control {
                            margin-top: 0;
                        }
                        .dropdown {
                            &::before {
                                content: none;
                            }
                        }
                        .header-row {
                            display: flex;
                            justify-content: space-between;
                            h5 {
                                font-size: 14px;
                                font-weight: 400;
                            }
                            h6 {
                                color: #727A82;
                                font-size: 14px;
                                font-weight: 400;
                            }
                        }

                        .mx-datepicker {
                            max-width: 100%;
                        }

                        footer {
                            padding: 0;
                        }
                        .error-msg {
                            position: absolute;
                            top: 100%;
                            left: 0;
                            color: #9f191f;
                            font-size: 12px;
                            white-space: nowrap;
                        }
                    }
                }
                .upload-image-header {
                    margin: 0 0 10px;
                    font-size: 14px;
                    font-weight: 400;
                }
                .image-upload-row {
                    .img-upload {
                        padding: 6px 12px;
                        background-color: #0088ff;
                        color: #fff;
                        font-size: 12px;
                        cursor: pointer;
                        input {
                            display: none;
                        }
                    }
                    .img-uploaded {
                        margin-left: 16px;
                        span {
                            margin-left: 12px;
                        }
                        .fa-close {
                            margin-left: 12px;
                            cursor: pointer;
                        }
                    }
                }
                .announcement-textarea {
                    margin-bottom: 20px;
                    border: 1px solid #c9cfd4;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    &:focus {
                        outline: none;
                    }
                }
                .annoucements-expire-row {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                    .column {
                        position: relative;
                        width: calc(50% - 10px);
                        .header-row {
                            display: flex;
                            justify-content: space-between;
                            h5 {
                                font-size: 14px;
                                font-weight: 400;
                            }
                            h6 {
                                color: #727A82;
                                font-size: 14px;
                                font-weight: 400;
                            }
                        }
                        .form-control {
                            margin-top: 0;
                        }
                        .dropdown {
                            &::before {
                                content: none;
                            }
                        }
                        .mx-datepicker {
                            max-width: 100%;
                        }
                        .error-msg {
                            position: absolute;
                            top: 100%;
                            left: 0;
                            color: #9f191f;
                            font-size: 12px;
                            white-space: nowrap;
                        }
                    }
                }
            }
            .announcement-content {
                padding: 20px;
                .announcement-preview {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 20px;
                    border: 1px solid #c9cfd4;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    h3 {
                        font-size: 15px;
                    }
                    h4 {
                        font-size: 14px;
                    }
                    .announcement-image {
                        margin-bottom: 30px;
                    }
                    p {
                        text-align: center;
                    }
                }
            }
        }
        .control-bar {
            width: 100%;
            justify-content: flex-end;
            margin-top: 20px;
            .btn-primary {
                margin-left: 12px;
            }
        }
        .mx-datepicker-popup {
            top: -200px !important;
        }
    }

    #previewModal___BV_modal_content_ {
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        border-radius: 20px;
    }

    #previewModal___BV_modal_body_ {
        .content {
            display: flex;
            flex-direction: column;
            align-items: center;
            .announcement-icon {
                margin-bottom: 12px;
            }
            h3 {
                margin: 0 0 16px;
                font-size: 14px;
                font-weight: 700;
            }
            p, ul, strong {
                width: 100%;
            }
            .announcement-image {
                height: 150px;
                width: auto;
                margin-bottom: 20px;
            }
        }
    }

    #expireModal___BV_modal_body_ {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        .fa-close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
        }
        .fa-window-close-o {
            font-size: 24px;
            margin-bottom: 12px;
            color: #0088ff;
        }
        h3 {
            margin: 0 0 18px;
            font-size: 15px;
            font-weight: 700;
        }
        p {
            text-align: center;
        }
        .btn-primary {
            margin-left: 10px;
        }
    }

    .dark-theme {
        .announcements {
            background-color: #3a4149;
            border-color: #1a1c1d;
            color: #fff;
            .filter-row {
                border-color: #1a1c1d;
                .search-box {
                    background-color: #515b65;
                    border-color: #1a1c1d;
                }
                .form-control {
                    background-color: #515b65;
                    border-color: #1a1c1d;
                    color: #fff;
                    &::placeholder {
                        color: #fff;
                    }
                }
            }
        }
        #editAnnouncement___BV_modal_body_,
        #addAnnouncement___BV_modal_body_ {
            .create-announcement {
                .announcement-inputs {
                    .announcement-select,
                    input,
                    .announcement-textarea {
                        background-color: #515b65;
                        color: #fff;
                        border-color: #1a1c1d;
                    }
                    .b-form-timepicker {
                        background-color: #515b65;
                        color: #fff;
                        border-color: #1a1c1d;
                        label {
                            color: #fff !important;
                        }
                        .dropdown-menu {
                            background-color: #515b65;
                            color: #fff;
                            border-color: #1a1c1d;
                            output {
                                background-color: #515b65;
                                color: #fff;
                                border-color: #1a1c1d !important;
                            }
                            .b-form-spinbutton {
                                background-color: #515b65;
                                color: #fff;
                                border-color: #1a1c1d;
                            }
                            circle {
                                color: #1a1c1d;
                            }
                            .b-form-date-controls {
                                .btn-sm {
                                    border-color: #1a1c1d;
                                }
                            }
                        }
                    }
                    .fa-info-circle {
                        &:hover {
                            span {
                                background-color: #515b65;
                                border-color: #1a1c1d;
                            }
                        }
                    }
                }
                .announcement-content {
                    .announcement-preview {
                        border-color: #1a1c1d;
                    }
                }
            }
            .control-bar {
                border-color: #1a1c1d;
            }
        }
        #previewModal___BV_modal_body_ {
            .content {
                border-color: #1a1c1d;
            }
        }
    }
</style>
